<template lang="pug">
.c-thumb-row(ref="row"
  :class="$style.thumbrow")
  base-thumb(v-for="(src, i) in thumbs"
    :key="src"
    :src="src"
    :class="getThumbClass(i)"
    @click.native="$emit('select:thumb', i)")
</template>

<script>
import BaseThumb from "@/components/BaseThumb.vue";

export default {
  name: "ThumbRow",
  components: {
    BaseThumb
  },
  props: {
    thumbs: {
      type: Array,
      default: () => []
    },
    current: {
      type: Number,
      default: 0
    }
  },
  watch: {
    current(val) {
      const row = this.$refs.row;

      row.scrollTo({
        left: row.children[val].offsetLeft - row.clientWidth / 2 + 55,
        behavior: "smooth"
      });
    }
  },
  methods: {
    getThumbClass(index) {
      return index === this.current
        ? [this.$style.thumb, this.$style.actived]
        : this.$style.thumb;
    }
  }
};
</script>

<style module lang="sass">
.thumbrow
  +size(100%, 130px)
  +flexbox(flex-start, flex-start)
  padding: 0
  overflow-x: scroll
  overflow-y: hidden
  white-space: nowrap

.thumbrow
  .thumb
    +pointer
    display: inline-flex
    margin: 0 2px
    flex: 0 0 110px
    img
      object-fit: cover

  .thumb.actived
    border: 2px yellow solid
</style>
